<template>
    <div class="quickDateSettings">
        <icon-button
            v-for="hour in hours"
            :key="hour"
            small
            :class="{ active: isHourSelected(hour) }"
            @click="setLastHours(hour)"
        >
            last {{ hourFormatter(hour) }}
        </icon-button>
    </div>
</template>

<script>
import IconButton from './iconButton/IconButton';

const MILLIS_PER_HOUR = 60 * 60 * 1000;

export default {
    name: 'QuickDateSettings',

    components: {
        IconButton
    },

    model: {
        prop: 'outerModel'
    },

    props: {
        outerModel: {
            type: Object,
            required: true,
            validator(value) {
                return value.from instanceof Date && value.to instanceof Date;
            }
        },
        hours: {
            type: Array,
            default: () => [3, 6, 12, 24, 72],
            validator(value) {
                return Array.isArray(value) && value.every(e => typeof e === 'number' && e % 1 === 0);
            }
        },
        hourFormatter: {
            type: Function,
            default: v => v + 'h'
        },
        keepMinutes: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        getNow() {
            const now = new Date();
            if (!this.keepMinutes) {
                now.setMinutes(0);
            }
            now.setSeconds(0);
            now.setMilliseconds(0);
            return now;
        },

        isHourSelected(hour) {
            return (
                +this.outerModel.to === +this.getNow() &&
                (this.outerModel.to - this.outerModel.from) / MILLIS_PER_HOUR === hour
            );
        },

        setLastHours(hour) {
            if (this.isHourSelected(hour)) {
                return;
            }

            const now = this.getNow();

            this.$emit('input', {
                from: new Date(+now - hour * MILLIS_PER_HOUR),
                to: now
            });

            this.$emit('select');
        }
    }
};
</script>

<style lang="scss">
.quickDateSettings {
    .iconButton:not(:first-child) {
        margin-left: 5px;
    }
}
</style>
